var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',_vm._b({attrs:{"value":_vm.selectedDateType,"items":_vm.dateTypes,"item-text":"label","item-value":"id"},on:{"input":_vm.handleSelectedDateTypeChange}},'v-autocomplete',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }